import React from 'react';
import Helmet from 'react-helmet';
import { Link, graphql } from 'gatsby';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import config from '../../data/SiteConfig';

const aMonthAgo = new Date();
aMonthAgo.setMonth(aMonthAgo.getMonth() - 1);

const Index = props => {
  const {
    data: {
      site: {
        siteMetadata: { title, titleTemplate, description, url, twitter },
      },
      talks: { nodes: talks },
      projects: { nodes: projects },
      allEventsJson: { edges: events },
    },
  } = props;
  return (
    <Layout
      {...{ title, titleTemplate, url, twitter, description }}
      className="max-width-40-rem"
    >
      <Helmet title={config.siteTitle} />
      <SEO />
      <section>
        <img src={config.userAvatar} alt="user avatar" className="avatar" />
        <h1>Hi, I'm Wei 👩🏻‍🌾</h1>
        <p>Welcome to my home on the open web. Here's a little bit about me:</p>
        <ul>
          <li>
            I was born and bred in&nbsp;
            <a href="https://www.youtube.com/watch?v=GKhD5kHb0gU">Beijing</a>
            &nbsp;and I'm currently based in Singapore 🇸🇬
          </li>
          <li>
            I studied{' '}
            <a href="https://www.math.ucdavis.edu/">pure math in college</a>. I
            still profoundly love it.
          </li>
          <li>
            I'm now a React web developer at{' '}
            <a href="https://shopee.sg/">Shopee</a>.
          </li>
          <li>
            I keep a <a href="https://aworkinprogress.dev/">dev blog here</a>.
          </li>
          <li>
            I love my local tech community. I actively speak at meetups here. I
            am running{' '}
            <a href="https://twitter.com/reknowledgeable/">
              React Knowledgeable
            </a>{' '}
            and co-organizing{' '}
            <a href="https://singaporecss.github.io/">SingaporeCSS</a>.{' '}
          </li>

          <li>
            You can find me on <a href="https://twitter.com/wgao19">Twitter</a>,{' '}
            <a href="https://github.com/wgao19">GitHub</a>, and check out{' '}
            <a href="https://instagram.com/_weiclimbs">
              my other life as a climber
            </a>
            .
          </li>
        </ul>
      </section>
      <section>
        <h2 id="projects">🖥&nbsp;Recent Projects</h2>
        {projects
          .filter(
            ({ frontmatter: { lastUpdate } }) =>
              new Date(lastUpdate) > aMonthAgo
          )
          .map(({ frontmatter, fields }) => (
            <React.Fragment key={`project-${frontmatter.title}`}>
              <div className="display-flex">
                <b>{frontmatter.title}</b>
                <Link
                  to={`/projects${fields.slug}`}
                  className="margin-left-auto"
                >
                  Read More
                </Link>
              </div>
              <p>{frontmatter.intro}</p>
            </React.Fragment>
          ))}
      </section>
      <section>
        <h2 id="events">
          <span role="img" aria-label="events">
            💁🏻‍♀️
          </span>
          &nbsp;Events & Conferences
        </h2>
        {events.map(({ node: eventYear }) => (
          <div key={`event-year-${eventYear.year}`}>
            <ul>
              <h3>{eventYear.year}</h3>
              {eventYear.events.map(event => (
                <li key={`event-${event.title}`}>
                  {event.date}
                  &nbsp;–&nbsp;
                  {event.website ? (
                    <a href={event.website}>
                      {event.title}
                      <svg
                        width="16px"
                        viewBox="0 0 511.626 511.627"
                        style={{
                          marginLeft: '.5em',
                          verticalAlign: 'middle',
                        }}
                      >
                        <g>
                          <path d="M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361    c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414    c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418    h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563    c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542    c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13    c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57    C397.709,293.209,395.519,292.354,392.857,292.354z" />
                          <path d="M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424    c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067    c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852    s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426    c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z" />
                        </g>
                      </svg>
                    </a>
                  ) : (
                    event.title
                  )}
                  {event.participation && (
                    <span>
                      &nbsp;–&nbsp;
                      {event.participation}
                    </span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </section>
      <section>
        <h2 id="talks">
          <span role="img" aria-label="talks">
            🎙
          </span>
          &nbsp;Talks
        </h2>
        <ul>
          {talks.map(node => {
            const {
              frontmatter: talk,
              fields: { slug },
            } = node;
            return (
              <li key={`talk-${talk.title}`}>
                <Link to={`/talks/${slug}`}>{talk.title}</Link>
                {talk.where && (
                  <i>
                    {' @ '}
                    <a href={talk.where.link}>
                      {talk.where.name}
                      <svg
                        width="16px"
                        viewBox="0 0 511.626 511.627"
                        style={{
                          marginLeft: '.5em',
                          verticalAlign: 'middle',
                        }}
                      >
                        <g>
                          <path d="M392.857,292.354h-18.274c-2.669,0-4.859,0.855-6.563,2.573c-1.718,1.708-2.573,3.897-2.573,6.563v91.361    c0,12.563-4.47,23.315-13.415,32.262c-8.945,8.945-19.701,13.414-32.264,13.414H82.224c-12.562,0-23.317-4.469-32.264-13.414    c-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562,4.471-23.313,13.417-32.259c8.947-8.947,19.702-13.418,32.264-13.418    h200.994c2.669,0,4.859-0.859,6.57-2.57c1.711-1.713,2.566-3.9,2.566-6.567V82.221c0-2.662-0.855-4.853-2.566-6.563    c-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648,0-42.016,8.042-58.102,24.125C8.042,113.297,0,132.665,0,155.313v237.542    c0,22.647,8.042,42.018,24.123,58.095c16.086,16.084,35.454,24.13,58.102,24.13h237.543c22.647,0,42.017-8.046,58.101-24.13    c16.085-16.077,24.127-35.447,24.127-58.095v-91.358c0-2.669-0.856-4.859-2.574-6.57    C397.709,293.209,395.519,292.354,392.857,292.354z" />
                          <path d="M506.199,41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948,0-9.233,1.807-12.847,5.424    c-3.617,3.615-5.428,7.898-5.428,12.847s1.811,9.233,5.428,12.85l50.247,50.248L198.424,304.067    c-1.906,1.903-2.856,4.093-2.856,6.563c0,2.479,0.953,4.668,2.856,6.571l32.548,32.544c1.903,1.903,4.093,2.852,6.567,2.852    s4.665-0.948,6.567-2.852l186.148-186.148l50.251,50.248c3.614,3.617,7.898,5.426,12.847,5.426s9.233-1.809,12.851-5.426    c3.617-3.616,5.424-7.898,5.424-12.847V54.818C511.626,49.866,509.813,45.586,506.199,41.971z" />
                        </g>
                      </svg>
                    </a>
                  </i>
                )}
              </li>
            );
          })}
        </ul>
      </section>
    </Layout>
  );
};

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
  query HomeQuery {
    site {
      siteMetadata {
        title
        description
        url
        twitter
        titleTemplate
      }
    }
    allEventsJson(sort: { order: DESC, fields: year }) {
      edges {
        node {
          year
          events {
            date
            title
            website
            participation
          }
        }
      }
    }
    talks: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/talks/" }
        frontmatter: { listed: { ne: false } }
      }
      sort: { fields: [frontmatter___when], order: DESC }
    ) {
      nodes {
        frontmatter {
          intro
          slides
          title
          video
          when
          where {
            link
            name
          }
          post
        }
        fields {
          slug
        }
      }
    }
    projects: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/projects/" } }
      sort: {
        fields: [frontmatter___lastUpdate, frontmatter___started]
        order: [DESC, DESC]
      }
    ) {
      nodes {
        frontmatter {
          title
          intro
          started
          links {
            link
            title
          }
          lastUpdate
        }
        fields {
          slug
        }
      }
    }
  }
`;
